<script>
export default {
  name: "Rich",
  props: {
    tag: {
      prop: String,
      default: "div",
    },
    value: {
      prop: String,
    },
  },
  render(h) {
    return h(this.tag, { class: "rich", domProps: { innerHTML: this.value } });
  },
};
</script>
<style lang="scss" scoped>
.rich {
  overflow: hidden;
  /deep/ {
    img {
      max-width: 100%;
      width: 100%;
      vertical-align: bottom;
    }
    video {
      display: unset;
      max-width: 100%;
    }
  }
}
</style>
